import en from './en';
import xx from './xx';

export default {
  en: en,
  xx: xx,
};
